import { queryOptions } from "@tanstack/react-query";
import Session from "supertokens-web-js/recipe/session";

import { parseAccessTokenPayload } from "@/helpers/jwt";

export const SESSION_IDENTITY_QUERY_KEY = ["session-credential-identity"] as const;

export function sessionIdentityQueryOptions() {
  return queryOptions({
    queryKey: SESSION_IDENTITY_QUERY_KEY,
    queryFn: async () => {
      if (!(await Session.doesSessionExist())) {
        return null;
      }

      return parseAccessTokenPayload(await Session.getAccessToken()) ?? null;
    },
    staleTime: Infinity,
    retry: false,
  });
}
